<template>
  <el-container v-loading="loading" class="member_info_container">
    <el-header>
      <span style="float: left;">{{ name }}</span>
      <el-button @click="closeInfo" type="danger"
                 :loading="false"
                 style="background-color: #272B43;margin-right: 10px;margin-top: 10px; float: right; z-index: 100; position:relative;"
                 icon="el-icon-close" circle></el-button>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <div class="block" style="margin-top: 20px">
          <img style="width: 150px; height: 150px; object-fit: cover; border-radius: 5px" :src="avatar"
               onerror="this.src='https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'">
        </div>
        <div class="block">
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            @select="handleSelect"
            background-color="#272B43"
            text-color="#A4D3E8"
            active-text-color="#FFF">
            <el-menu-item index="1">
              General Information
            </el-menu-item>
            <el-menu-item index="2">
              View Statistics
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <div v-if="index == 1">
          <div class="basic_title">
            Basic Information
          </div>
          <div class="basic_content">
            <div class="basic_content_item">
              <span>Gender:</span><span class="basic_content_item_value">{{ gender }}</span>
            </div>
            <div class="basic_content_item">
              <span>Nationality:</span><span class="basic_content_item_value">{{ nationality }}</span>
            </div>
            <div class="basic_content_item">
              <span>Birth Date:</span><span class="basic_content_item_value">{{ birth_date }}</span>
            </div>
            <div class="basic_content_item">
              <span>Race:</span><span class="basic_content_item_value">{{ race }}</span>
            </div>
            <div class="basic_content_item">
              <span>ID/Pass Type:</span><span class="basic_content_item_value">{{ pass_type }}</span>
            </div>
            <div class="basic_content_item">
              <span>ID/Pass No.:</span><span class="basic_content_item_value">{{ pass_no }}</span>
            </div>
            <div class="basic_content_item">
              <span>Category:</span><span class="basic_content_item_value">{{ category }}</span>
            </div>
            <div class="basic_content_item">
              <span>Type of Worker:</span><span class="basic_content_item_value">{{ type_of_worker }}</span>
            </div>
            <div class="basic_content_item">
              <span>Joined Date:</span><span class="basic_content_item_value">{{ joined_date }}</span>
            </div>
            <div class="basic_content_item">
              <span>Designation:</span><span class="basic_content_item_value">{{ designation }}</span>
            </div>
          </div>
          <div class="train_title">
            Training Records
          </div>
          <div class="train_content">
            <el-table
              :data="trainings"
              max-height="150"
              border
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              style="margin: 20px 40px;">
              <el-table-column
                type="index"
                label="S/N"
                width="50">
              </el-table-column>
              <el-table-column
                prop="type_name_en"
                label="Type"
                width="400">
              </el-table-column>
              <el-table-column
                prop="training_id"
                label="No.">
              </el-table-column>
              <el-table-column
                prop="start_time"
                :formatter="startDateFormat"
                label="Issue Date"
                width="140">
              </el-table-column>
              <el-table-column
                prop="end_time"
                :formatter="endDateFormat"
                label="Expiry Date"
                width="140">
              </el-table-column>

            </el-table>
          </div>
        </div>
        <div v-if="index == 2">
          <div class="statistics_title">
            Statistics
          </div>
          <div class="statistics_content">
            <el-radio-group v-model="statistics_radio" style="margin: 10px auto 10px auto;"
                            text-color="#000"
                            @change="changeLabel"
                            fill="#01A3E8">
              <!--<el-radio-button label="TBM"></el-radio-button>
              <el-radio-button label="PTW"></el-radio-button>
              <el-radio-button label="Inspection"></el-radio-button>
              <el-radio-button label="Training"></el-radio-button>
              <el-radio-button label="Meeting"></el-radio-button>
              <el-radio-button label="Incident"></el-radio-button>-->
              <el-radio-button v-for="item in labels" :key="item.id" :label="item.name"></el-radio-button>
            </el-radio-group>
            <div style="width: 750px; margin: 10px auto 30px auto;">
              <el-table
                :data="label"
                border
                max-height="400"
                :row-style="tableRowStyle"
                :header-cell-style="tableHeaderColor"
                style="margin: 0 auto;">
                <el-table-column
                  prop="type_name_en"
                  label="Type">
                </el-table-column>
                <el-table-column
                  prop="type_name_en"
                  :formatter="showPtwRole"
                  label="Role">
                </el-table-column>
                <el-table-column
                  prop="count"
                  label="Count"
                  width="100">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

import axios from 'axios'

export default {
  name: "memberinfo",
  props: ['project_id', 'user_id'],
  data() {
    return {
      my_user_id: this.user_id,
      radio: 'General Information',
      statistics_radio: 'PTW',
      index: 1,
      active: 1,
      tabPosition: 'top',
      trainings: [],
      loading: true,
      name: '',
      avatar: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
      gender: '',
      nationality: '',
      birth_date: '',
      race: '',
      pass_type: '',
      pass_no: '',
      category: '',
      type_of_worker: '',
      joined_date: '',
      designation: '',
      label_role: '',
      ptw_role: '-',
      tbm_role: '-',
      inspection_role: '-',
      training_role: '-',
      meeting_role: '-',
      incident_role: '-',
      label: [],
      ptws: [],
      tbms: [],
      inspections: [],
      training: [],
      meetings: [],
      incidents: [],
      labels: [
        {id: 'tbms', name: 'TBM'},
        {id: 'ptws', name: 'PTW'},
        {id: 'inspections', name: 'Inspection'},
        {id: 'training', name: 'Training'},
        {id: 'meetings', name: 'Meeting'},
        {id: 'incidents', name: 'Incident'}
      ]
    }
  },
  methods: {
    closeInfo() {
      this.my_user_id = ''
    },
    errorHandler() {
      return true
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.index = key
    },
    handleActive(key, keyPath) {
      this.active = key
    },
    handleClick(tab, event) {
      console.log(tab.name);
      console.log(event);
    },
    // 修改table tr行的背景色
    tableRowStyle({row, rowIndex}) {
      if (rowIndex % 2 == 0) {
        return 'background-color: #F4D347'
      } else {
        return 'background-color: #FBEDB5'
      }
    },
    // 修改table header的背景色
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return 'background-color: black;color: #fff;font-weight: 400'
      }
    },
    dateFormat(cnTime) {
      if (cnTime == '') {
        return ''
      }
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      let date = cnTime.split(' ')[0]
      let time = cnTime.split(' ')[1]
      let dates = date.split('-')
      var newDate = dates[2] + ' ' + months[Number(dates[1]) - 1] + ' ' + dates[0]
      return newDate
    },
    startDateFormat(row, column) {
      let cnTime = row.start_time
      if (cnTime == '') {
        return ''
      }
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      let date = cnTime.split(' ')[0]
      let time = cnTime.split(' ')[1]
      let dates = date.split('-')
      var newDate = dates[2] + ' ' + months[Number(dates[1]) - 1] + ' ' + dates[0]
      return newDate
    },
    endDateFormat(row, column) {
      let cnTime = row.end_time
      if (cnTime == '') {
        return ''
      }
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      let date = cnTime.split(' ')[0]
      let time = cnTime.split(' ')[1]
      let dates = date.split('-')
      var newDate = dates[2] + ' ' + months[Number(dates[1]) - 1] + ' ' + dates[0]
      return newDate
    },
    changeLabel(label) {
      var that = this
      switch (label) {
        case 'Incident': {
          that.label = that.incidents
          that.label_role = that.incident_role
          break
        }
        case 'TBM': {
          that.label = that.tbms
          that.label_role = that.tbm_role
          break
        }
        case 'Inspection': {
          that.label = that.inspections
          that.label_role = that.inspection_role
          break
        }
        case 'Training': {
          that.label = that.training
          that.label_role = that.training_role
          break
        }
        case 'Meeting': {
          that.label = that.meetings
          that.label_role = that.meeting_role
          break
        }
        case 'PTW': {
          that.label = that.ptws
          that.label_role = that.ptw_role
          break
        }
      }
    },
    showPtwRole(row, column) {
      return this.label_role
    }
  },
  watch: {
    user_id(val) {
      this.my_user_id = val
    },
    my_user_id(val) {
      this.$emit('update:user_id', val)
    }
  },
  mounted() {
    var that = this
    let postData = {
      project_id: that.project_id,
      user_id: that.user_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjMemberInfo", postData).then(resp => {    //生产
      that.loading = false
      var errNo = resp.data.errno
      var errStr = resp.data.errstr
      if (errNo == "0") {
        var result = resp.data.result;
        that.name = result.name
        that.gender = result.gender
        that.nationality = result.nationality
        that.birth_date = result.birth_date
        that.race = result.race
        that.pass_type = result.pass_type
        that.pass_no = result.pass_no
        that.category = result.category
        that.type_of_worker = result.type_of_worker
        that.joined_date = that.dateFormat(result.joined_time)
        that.designation = result.designation
        //role start
        that.ptw_role = result.ptw_role
        that.training_role = result.training_role
        that.meeting_role = result.meeting_role
        if (result.tbm_role) {
          that.tbm_role = result.tbm_role
        }
        if (result.inspection_role) {
          that.inspection_role = result.inspection_role
        }
        if (result.incident_role) {
          that.incident_role = result.incident_role
        }
        //role end
        var ptws = result.ptws
        if (ptws.length > 0) {
          that.ptws = ptws
        } else {
          that.ptws = []
        }
        var incidents = result.incidents
        if (incidents.length > 0) {
          that.incidents = incidents
        } else {
          that.incidents = []
        }
        var inspections = result.inspections
        if (inspections.length > 0) {
          that.inspections = inspections
        } else {
          that.inspections = []
        }
        var training = result.training
        if (training.length > 0) {
          that.training = training
        } else {
          that.training = []
        }
        if (result.tbms && result.tbms.length > 0) {
          that.tbms = result.tbms
        } else {
          that.tbms = []
        }
        if (result.meetings && result.meetings.length > 0) {
          that.meetings = result.meetings
        } else {
          that.meetings = []
        }
        var avatar = result.avatar
        console.log("avatar...", result.avatar)
        if (avatar.indexOf('filebase') >= 0) {
          that.avatar = that.$store.getters.getServer241Address + 'getfile/filebase' + avatar.split('filebase')[1]
        }
        var trainings = result.trainings
        if (trainings.length > 0) {
          that.trainings = trainings
        } else {
          that.trainings = []
        }
        //初始显示PTW
        that.label = that.ptws
        that.label_role = that.ptw_role
      } else {
        alert(errStr)
      }
    }).catch(error => {
      that.loading = false
      alert(error)
    })
  }
}

</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

.member_info_container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: #FFF
  background-color #272B43
}

.el-header {
  font-size 32px
  line-height: 60px;
}

.el-aside {
  text-align: center;
  font-size 12px
}

.el-main {
  margin-top -30px
  text-align: center;
}

.el-menu {
  border-right: 0;
}

.el-menu-item {
  font-size 18px
  height: 40px
  line-height 40px
}

.basic_content {
  position: relative
  width: 90%;
  min-height 250px
  border-radius: 5px;
  border: 2px solid #eee;
  font-size 22px
  padding-top 20px
  margin -13px auto 0 auto
  z-index 2
  display: flex
  flex-wrap: wrap;
  justify-content left
}

.basic_title {
  position: relative
  font-size: 20px;
  background #272B43
  width 180px
  z-index 3
  margin: 0 auto
}

.basic_content_item {
  margin-right 70px
  margin-bottom 20px
  margin-left 20px
}

.basic_content_item_value {
  margin-left 14px
}

.train_content {
  position: relative
  width: 90%;
  border-radius: 5px;
  border: 2px solid #eee;
  font-size 22px
  padding-top 20px
  margin -13px auto 0 auto
  z-index 2
  display: flex
  flex-wrap: wrap;
  justify-content left
}

.train_title {
  position: relative
  font-size: 20px;
  background #272B43
  width 180px
  z-index 3
  margin: 30px auto 0 auto
}

.el-table td, .el-table th.is-leaf, .el-table--border, .el-table--group {
  border-color: black;
}

.el-table--border::after, .el-table--group::after, .el-table::before {
  background-color: black;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 20px;
  text-align center
}

.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 30px;
  text-align center
  color: #000
}

.statistics_content {
  position: relative
  width: 80%;
  border-radius: 5px;
  border: 2px solid #eee;
  font-size 22px
  padding-top 20px
  margin -13px auto 0 auto
  z-index 2
  display: flex
  flex-wrap: wrap;
  justify-content left
}

.statistics_title {
  position: relative
  font-size: 20px;
  background #272B43
  width 110px
  z-index 3
  margin: 0 auto
}

.el-radio-button__inner {
  background #7F7F7F
  color: #000
  width: 125px
}

</style>



// WEBPACK FOOTER //
// src/components/manpower/memberinfo.vue